
import TitleBox from '@/components/CSS/TitleBox'
import Upload from '@/components/Upload'
import { mapGetters } from 'vuex'
// import { suggestionSava, suggestionTypeList } from "@/api/common";
import { UPLOAD_COMMON_TYPE } from '@/enum/uploadType'
import Breadcrumb from '@/components/Breadcrumb'

export default {
    components: {
        TitleBox,
        Upload,
        Breadcrumb,
    },
    props: {
        components: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters({
            userinfo: 'user/userinfo',
            token: 'user/token'
        })
    },
    data() {
        return {
            isShowIdentityId: false,
            loading: false,
            submitLoading: false,
            form: {
                problemId: null,
                content: null,
                imageList: null,
                phone: null,
                qq: null,
                gameId: null,
                identityId: null,
            },
            rules: {
                gameId: [{ required: true, message: '请选择关联游戏', trigger: 'change' }],
                // identityId: [{ required: true, message: '请选择我的身份', trigger: 'change' }],
                problemId: [{ required: true, message: '请选择问题类型', trigger: 'change' }],
                // imageList: [{ required: true, message: '请上传问题图片', trigger: 'change' }],
                content: [
                    { required: true, message: '请输入详情内容', trigger: 'blur' },
                    { min: 15, message: '最少输入15个字', trigger: 'blur' }
                ]
            },
            typeList: [],
            UPLOAD_COMMON_TYPE,
            gameList: [],
            standList: [],
        }
    },
    methods: {

        getGamesList() {
            const data = {
                action: {
                    firstChar: null,
                    gameCatalogueId: null
                }
            }
            this.$api.gameAll(data).then(res => {
                if (!res.success) {
                    this.$message.error(res.info)
                    return
                }
                this.gameList = res.data
            })
        },
        getStandList() {
            this.$api.listByLevel().then(res => {
                if (!res.success) {
                    this.$message.error(res.info)
                    return
                }
                this.standList = res.data
            })
        },
        getSuggestionTypeList() {
            this.$api.listByPId({ pid: this.form.identityId }).then(res => {
                if (!res.success) {
                    this.$message.error(res.info)
                    return
                }
                this.typeList = res.data
            })
        },
        onChangeStand(item) {

            this.form.problemId = null
            this.form.identityId = item.id
            if (this.form.identityId)
                this.isShowIdentityId = false
            if (this.form.identityId)
                this.getSuggestionTypeList()


        },
        onSubmit() {
            if (!this.form.identityId) {
                this.isShowIdentityId = true
            }
            this.$refs['ruleForm'].validate(valid => {
                if (valid) {
                    this.submitLoading = true
                    let p = {
                        action: this.form
                    }
                    this.$api.suggestionSava(p).then(res => {
                        this.submitLoading = false
                        if (!res.success) {
                            this.$message.error(res.info)
                            return
                        }
                        this.$message.success(res.info)
                        this.$refs['ruleForm'].resetFields()
                        this.form = {
                            // qq: null
                            gameId: null,
                            identityId: null,
                            problemId: null,
                            content: null,
                            imageList: null,
                            phone: null,
                        }
                        // this.form.qq = this.userinfo.qq
                        if (!this.components) {
                            this.$router.go(-1)
                        }
                    })
                } else {
                    this.submitLoading = false
                    //自动定位到错误的地方
                    setTimeout(() => {
                        let isError = document.getElementsByClassName('is-error')
                        if (isError[0]?.querySelector('input')) {
                            isError[0]?.querySelector('input').focus()
                        }
                    }, 100)
                }
            })
        },


    },
    mounted() {
        if (!this.token) {
            this.$router.push('/login?redirect=/business?title=投诉建议')
            return
        }
        // this.form.qq = this.userinfo.qq
        // this.$store.dispatch('AppGetOssAuth')
        this.getGamesList()
        this.getStandList()
    }
}
